import React from 'react';
import {connect} from 'react-redux';
import {ComboExposureMax as BaseComboExposureMax} from 'components/molecules/combo-exposure-max';
import Action from 'components/organisms/correlation-stacked-teams-list/actions';

class ComboExposureMax extends BaseComboExposureMax {
    constructor(props) {
        super(props);
        this.action = Action;
    }
}

function mapStatesToProps(state) {
    const {
        correlationStacking: {combinations},
    } = state;

    return {
        comboExpMax: combinations.exposureMax,
    };
}

export default connect(mapStatesToProps)(ComboExposureMax);
